module.exports = __webpack_public_path__ + "img/syl_gallery2.296f9f30.jpg";